import React from 'react'
import tickIcon from '@/assets/images/svg/stepper/tick-icon.svg';

const FeatureCard = ({planName,features = []}) => {
  return (
    <div className='feature-card'>
       <div className='feature-header'>
             <h4>{planName} Features</h4>
       </div>
       <div className='feature-body row gx-4'>
         {features.map((item, index)=>(
            <div className='feature-item col-lg-6' key={index}>
              <div className='row'>
                <div className='feature-left col-md-9'>
                      <img src={tickIcon} alt='tick-icon' />
                     <span>{item.key_name ? item.key_name : '-' }</span>
                </div>
                     <strong className='feature-value col-md-3'>{item.key_value ? item.key_value : '-'}</strong>
            </div>
            </div>
         )
        )}
       </div>
    </div>
  )
}

export default FeatureCard
